<template>
  <div id="internal-report-summary" v-if="reportData.campaign">
    <section id="postSummary" v-if="reportData.campaign.enablePostAnalysis && postsAnalysisData.length > 0">
      <post-summary :posts="postsAnalysisData" :defaultCols="defaultPostsAnalysisStatus" :campaign="reportData.campaign" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('post','IG Post', postsAnalysisData)" />
    </section>
    <section id="reelSummary" v-if="reportData.campaign.enableReelAnalysis && reelAnalysisData.length > 0">
      <reel-summary :posts="reelAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultReelAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('reel','IG Reel', reelAnalysisData)" />
    </section>
    <section id="storySummary" v-if="storyAnalysisData.length > 0" >
      <story-summary :posts="storyAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultStoryAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('story','IG Story', storyAnalysisData)" />
    </section>
    <section id="tiktokSummary" v-if="reportData.campaign.enableTikTokAnalysis && tikTokAnalysisData.length > 0">
      <tiktok-summary :posts="tikTokAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultTikTokAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('tiktok','TikTok Post', tikTokAnalysisData)" />
    </section>
    <section id="youtubeSummary" v-if="reportData.campaign.enableYoutubeAnalysis && youtubeAnalysisData.length > 0">
      <youtube-summary :posts="youtubeAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultYoutubeAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('youtube','YouTube Post', youtubeAnalysisData)" />
    </section>
    <section id="fbSummary" v-if="reportData.campaign.enableFbAnalysis && fbAnalysisData.length > 0">
      <fb-summary :posts="fbAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultFbAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('facebook','Facebook', fbAnalysisData)" />
    </section>
    <section id="linkedInSummary" v-if="reportData.campaign.enableLinkedInAnalysis && linkedInAnalysisData.length > 0">
      <fb-summary summaryType="linkedin" :posts="linkedInAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultLinkedInAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('linkedin','LinkedIn', linkedInAnalysisData)" />
    </section>
    <section id="twitterSummary" v-if="reportData.campaign.enableTwitterAnalysis && twitterAnalysisData.length > 0">
      <fb-summary summaryType="twitter" :posts="twitterAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultTwitterAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('twitter','X (Twitter)', twitterAnalysisData)" />
    </section>
    <section id="xhsSummary" v-if="reportData.campaign.enableXHSAnalysis && xhsAnalysisData.length > 0">
      <xhs-summary :posts="xhsAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultXhsAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('xhs','XHS', xhsAnalysisData)" />
    </section>
    <section id="lemonSummary" v-if="reportData.campaign.enableLemonAnalysis && lemonAnalysisData.length > 0">
      <lemon-summary :posts="lemonAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultLemonAnalysisStatus" :isInternalView="true" @refreshReportInf="refreshReportInf" @open-analysis="openAi('lemon','Lemon8', lemonAnalysisData)" />
    </section>
    <table-ai-analysis-modal
      v-model="aiDialog"
      :campaign="reportData.campaign"
      :posts="aiPosts"
      :typeKey="aiTypeKey"
      :label="aiLabel" />
  </div>
</template>

<script>
/* eslint-disable */
import AOS from 'aos';
import 'aos/dist/aos.css';
import PostSummary from './PostSummary'
import ReelSummary from './ReelSummary'
import StorySummary from './StorySummary'
import TiktokSummary from './TiktokSummary'
import YoutubeSummary from './YoutubeSummary'
import FbSummary from './FbSummary'
import XhsSummary from './XHSSummary'
import LemonSummary from './LemonSummary'
import TableAiAnalysisModal from '../views/Campaign/TableAiAnalysisModal'
import campaignHelper from '../views/Campaign/campaignHelper'
import { getReportPlatform, getReportProfileUrl } from '@/utils/reportPlatform'
import utils from '../../utils'
import campaignAPIs from '../views/Campaign/campaignAPIs'

export default {
  name: 'ReportForSummary',
  components: {
    PostSummary,
    ReelSummary,
    StorySummary,
    TiktokSummary,
    YoutubeSummary,
    FbSummary,
    XhsSummary,
    LemonSummary,
    TableAiAnalysisModal
  },
  props: {
    respData: {
      type: Object,
      required: true
    },
    campaignID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      reportData: {campaign: null},
      // per-table AI analysis dialog (opened from a section header's AI button)
      aiDialog: false,
      aiTypeKey: '',
      aiLabel: '',
      aiPosts: [],
      postsAnalysisData: [],
      reelAnalysisData: [],
      storyAnalysisData: [],
      tikTokAnalysisData: [],
      youtubeAnalysisData: [],
      xhsAnalysisData: [],
      lemonAnalysisData: [],
      fbAnalysisData: [],
      linkedInAnalysisData: [],
      twitterAnalysisData: [],
      defaultPostsAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showEngagement: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false
      },
      defaultReelAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: true,
        showPlays: false,
        showWatches: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultStoryAnalysisStatus: {
        liveDate: false,
        outreach: true,
        showReach: false,
        showImpressions: true,
        showStoryLikes: true,
        showReplies: true,
        showShares: true,
        showLinkClicks: true,
        showStickerTaps: true,
        showInteractions: false,
        showNewEngagementRate: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultTikTokAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showPlays: true,
        showWatches: true,
        likes: true,
        comments: true,
        shares: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: false,
        showReach: false,
        showImpressions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        avgSaves: false,
        avgShares: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateTotalViewers: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showWatchedFullVideo: false
      },
      defaultYoutubeAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showViews: true,
        likes: true,
        comments: true,
        showInteractions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        showEngagement: true,
        showEngagementView: false,
        showAvgEngagement: false,
        showMediaEngagement: false
      },
      defaultPerformanceAnalysisStatus: {
        totalContents: true,
        totalOutreach: true,
        contents: true,
        outreach: true,
        interactions: true,
        outreachImpressions: true,
        postEngRate: false,
        reelEngRate: false,
        tiktokEngRate: false,
        youtubeEngRate: false,
        postEngRateView: false,
        reelEngRateView: false,
        tiktokEngRateView: false,
        youtubeEngRateView: false,
        industryBenchmark: false
      },
      defaultXHSAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultLemonAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultFbAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showLikes: true,
        showComments: true,
        showViews: true,
        showShares: true,
        showBookmarks: false,
        showInteractions: false
      },
      defaultLinkedInAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showReach: true,
        showVideoViews: true,
        showProfileViewers: true,
        showLikes: true,
        showComments: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      defaultTwitterAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showComments: true,
        showLikes: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      }
    }
  },
  watch: {
    campaignID: {
      handler: 'processReportData',
      immediate: true,
      deep: true
    }
  },
  methods: {
    // Open the shared per-table AI analysis dialog for one summary section.
    // typeKey is the CANONICAL section key (post/reel/story/tiktok/…), which is
    // what campaign.AITableSummaries is keyed by and what the Kobe report maps
    // flat report types onto (AI_TABLE_KEY: post/carousel->post, gdrive->story).
    // Note the IG Story section (storyAnalysisData) contains both 'story' and
    // 'gdrive' flat types but shares the single canonical key 'story'.
    openAi (typeKey, label, posts) {
      this.aiTypeKey = typeKey
      this.aiLabel = label
      this.aiPosts = posts || []
      this.aiDialog = true
    },
    resetReportData() {
      this.reportData = {campaign: null}
      this.postsAnalysisData = []
      this.reelAnalysisData = []
      this.storyAnalysisData = []
      this.tikTokAnalysisData = []
      this.youtubeAnalysisData = []
      this.xhsAnalysisData = []
      this.lemonAnalysisData = []
      this.fbAnalysisData = []
      this.linkedInAnalysisData = []
      this.twitterAnalysisData = []
    },
    async processReportData(reportData = this.respData) {
      this.$emit('loading-status', true);
      try {
      let response = reportData && reportData.campaign_details
        ? { success: true, data: reportData }
        : await campaignAPIs.generateCampaignReport(this.campaignID, null, false)
      if (!response || !response.success || !response.data || !response.data.campaign_details) {
        this.resetReportData()
        return
      }
      let newData = JSON.parse(JSON.stringify(response.data));
      newData.summary = newData.summary || {}
      newData.client = newData.client || {}
      newData.posts = Array.isArray(newData.posts) ? newData.posts.filter(Boolean) : []
      let campaign = {};
      campaign.id = newData.campaign_details.id;
      campaign.name = newData.campaign_details.name;
      campaign.campaignType = newData.campaign_details.campaignType;
      campaign.objectives = newData.campaign_details.goal;
      campaign.deliverables = [`Total ${newData.summary.contents} contents`];
      campaign.angles = newData.campaign_details.angles ? campaignHelper.fixAnglesData(newData.campaign_details.angles) : []
      campaign.segment = newData.campaign_details.segment || campaignHelper.getDefaultSegments()
      campaign.lineUp = newData.campaign_details.lineUp || []
      const settings = newData.campaign_details.settings || {}
      campaign.enablePostAnalysis = settings.enablePostAnalysis !== false;
      campaign.enableReelAnalysis = settings.enableReelAnalysis !== false;
      campaign.enableTikTokAnalysis = settings.enableTikTokAnalysis !== false;
      campaign.enableYoutubeAnalysis = settings.enableYoutubeAnalysis !== false;
      campaign.enableFbAnalysis = settings.enableFbAnalysis !== false;
      campaign.enableLinkedInAnalysis = settings.enableLinkedInAnalysis !== false;
      campaign.enableTwitterAnalysis = settings.enableTwitterAnalysis !== false;
      campaign.enableXHSAnalysis = settings.enableXHSAnalysis !== false;
      campaign.enableLemonAnalysis = settings.enableLemonAnalysis !== false;
      campaign.enableOverallSection = newData.campaign_details.settings ? newData.campaign_details.settings.enableOverallSection : false;
      campaign.postAnalysisStatus = newData.campaign_details.postAnalysisStatus || this.defaultPostsAnalysisStatus;
      campaign.reelAnalysisStatus = newData.campaign_details.reelAnalysisStatus || this.defaultReelAnalysisStatus;
      campaign.storyAnalysisStatus = newData.campaign_details.storyAnalysisStatus || this.defaultStoryAnalysisStatus;
      campaign.tikTokAnalysisStatus = newData.campaign_details.tikTokAnalysisStatus || this.defaultTikTokAnalysisStatus;
      campaign.youtubeAnalysisStatus = newData.campaign_details.youtubeAnalysisStatus || this.defaultYoutubeAnalysisStatus;
      campaign.performanceAnalysisStatus = newData.campaign_details.performanceAnalysisStatus || this.defaultPerformanceAnalysisStatus;
      campaign.fbAnalysisStatus = newData.campaign_details.fbAnalysisStatus || this.defaultFbAnalysisStatus;
      campaign.linkedInAnalysisStatus = Object.assign({}, this.defaultLinkedInAnalysisStatus, newData.campaign_details.linkedInAnalysisStatus || {});
      campaign.twitterAnalysisStatus = Object.assign({}, this.defaultTwitterAnalysisStatus, newData.campaign_details.twitterAnalysisStatus || {});
      campaign.xhsAnalysisStatus = newData.campaign_details.xhsAnalysisStatus || this.defaultXHSAnalysisStatus;
      campaign.lemonAnalysisStatus = newData.campaign_details.lemonAnalysisStatus || this.defaultLemonAnalysisStatus;
      campaign.startDate = newData.campaign_details.startDate || ''
      campaign.endDate = newData.campaign_details.endDate || ''
      campaign.optionalRemarks = newData.campaign_details.optionalRemarks || ''
      // per-table AI analysis paragraphs (keyed by canonical section key) —
      // must be carried over so the AI Analysis modal loads existing summaries
      campaign.AITableSummaries = newData.campaign_details.AITableSummaries || {}
      campaign.kpi = {
        post: newData.campaign_details.kpi && newData.campaign_details.kpi.post ? newData.campaign_details.kpi.post : {},
        story: newData.campaign_details.kpi && newData.campaign_details.kpi.story ? newData.campaign_details.kpi.story : {},
        reel: newData.campaign_details.kpi && newData.campaign_details.kpi.reel ? newData.campaign_details.kpi.reel : {},
        tiktok: newData.campaign_details.kpi && newData.campaign_details.kpi.tiktok ? newData.campaign_details.kpi.tiktok : {},
        youtube: newData.campaign_details.kpi && newData.campaign_details.kpi.youtube ? newData.campaign_details.kpi.youtube : {}
      }
      campaign.summary = newData.summary;
      campaign.client = {
        name: newData.client.name,
        logo: newData.client.logo
      }
      let posts = newData.posts.map((post, index) => {
        if (post.reportGroup) {
          let reports = Array.isArray(post.reports) ? post.reports : []
          post.reports = reports.map(p => this.calculatePostData(p, index))
        } else {
          post = this.calculatePostData(post, index)
        }
        return post
      })
      posts = Object.assign([], posts).sort((a, b) => a.lineUpIndex - b.lineUpIndex);
      
      this.reportData.campaign = Object.assign({}, campaign)

      // posts / carousel
      this.postsAnalysisData = posts.filter(post => (post.type !== 'story' && post.type !== 'tiktok' && post.type !== 'youtube' && post.type !== 'xhs' && post.type !== 'lemon' && post.type !== 'facebook' && post.type !== 'linkedin' && post.type !== 'twitter' && post.type !== 'gdrive' && post.type !== 'reel')) // for post summary
      this.postsAnalysisData.map(post => {
        post.new_engagement_rate = Number((((post.likes + post.comments + post.saved + post.shares) / post.outreach) * 100).toFixed(2))
        post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
        post.engagement_rate_reach = Number((((post.likes + post.comments + post.saved + post.shares) / post.reach) * 100).toFixed(2))
        post.interactions = ((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
      })
      this.postsAnalysisData = this.postsAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // Reel
      this.reelAnalysisData = posts.filter(post => post.type === 'reel') // for reel summary
      this.reelAnalysisData.map(post => {
        post.interactions = Number(post.likes + post.comments + post.saved + post.shares)
        post.new_engagement_rate = Number((((post.likes + post.comments + post.saved + post.shares) / post.outreach) * 100).toFixed(2))
        post.interaction_rate_plays = 0
        if (post.views) {
          post.interaction_rate_plays = Number((((post.likes + post.comments + post.saved + post.shares) / Number(post.views)) * 100).toFixed(2))
        }
        post.engagement_rate_reach = Number((((post.likes + post.comments + post.saved + post.shares) / Number(post.reach)) * 100).toFixed(2))
        post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
      })
      this.reelAnalysisData = this.reelAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // TikTok
      this.tikTokAnalysisData = posts.filter(post => (post.type === 'tiktok')) // for post summary
      this.tikTokAnalysisData.map(post => {
        post.new_engagement_rate = ((((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / (post.outreach || 0)) * 100).toFixed(2)
        post.interactions = Number((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
        post.interaction_rate_plays = 0
        post.eng_rate_total_viewers = 0
        if (post.views) {
          post.interaction_rate_plays = ((((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / Number(post.views)) * 100).toFixed(2)
          post.eng_rate_total_viewers = ((((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0)) / Number(post.reach)) * 100).toFixed(2)
        }
        post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
      })
      this.tikTokAnalysisData = this.tikTokAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // Youtube
      this.youtubeAnalysisData = posts.filter(post => (post.type === 'youtube')) // for youtube summary
      this.youtubeAnalysisData.map(post => {
        post.new_engagement_rate = ((((post.likes || 0) + (post.comments || 0)) / (post.outreach || 0)) * 100).toFixed(2)
        post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
        post.interactions = Number(((post.likes || 0) + (post.comments || 0)))
      })
      this.youtubeAnalysisData = this.youtubeAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // Story Analysis
      this.storyAnalysisData = posts.filter(post => (post.type === 'story' || post.type === 'gdrive')) // for story summary
      this.storyAnalysisData.map(post => {
        post.interactions = ((post.shares || 0) + (post.replies || 0) + (post.link_clicks || 0) + (post.sticker_taps || 0) + (post.story_likes || 0))
        post.new_engagement_rate = ((((post.interactions || 0)) / (post.outreach || 0)) * 100).toFixed(2)
      })
      this.storyAnalysisData = this.storyAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // FB Analysis
      this.fbAnalysisData = posts.filter(post => (post.type === 'facebook')) // for xhs summary
      this.fbAnalysisData.map(post => {
        post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
      })
      // LinkedIn Analysis
      this.linkedInAnalysisData = posts.filter(post => post.type === 'linkedin')
      this.linkedInAnalysisData.map(post => {
        post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.shares || 0))
      })
      this.linkedInAnalysisData = this.linkedInAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // X Analysis
      this.twitterAnalysisData = posts.filter(post => post.type === 'twitter')
      this.twitterAnalysisData.forEach(post => {
        post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
      })
      this.twitterAnalysisData = this.twitterAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // XHS Analysis
      this.xhsAnalysisData = posts.filter(post => (post.type === 'xhs')) // for xhs summary
      this.xhsAnalysisData.map(post => {
        post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
      })
      this.xhsAnalysisData = this.xhsAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      // Lemon Analysis
      this.lemonAnalysisData = posts.filter(post => (post.type === 'lemon')) // for lemon summary
      this.lemonAnalysisData.map(post => {
        post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
      })
      this.lemonAnalysisData = this.lemonAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
      AOS.init()
      window.onscroll = function() {
        setTimeout(function() {
          let favBtn = document.getElementById('goTop')
          if (favBtn) {
            // console.log('Scroll Top', document.documentElement.scrollTop)
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 800) {
              favBtn.style.display = 'block';
            } else {
              favBtn.style.display = 'none'
            }
          }
        }, 500)
      }
      } catch (error) {
        this.resetReportData()
        console.error(error)
      } finally {
        this.$emit('loading-status', false);
      }
    },
    calculatePostData(post, index) {
      const platform = getReportPlatform(post)
      let postData = {}
      postData.id = post.id
      postData.campaignID = post.campaignID
      postData.key = index
      postData.lineUpIndex = post.lineUpIndex
      postData.groupID = post.groupID
      postData.groupName = post.groupName
      const profileOwner = post.owner || (post.post_details || {}).owner || {}
      postData.profileUrl = getReportProfileUrl(post, platform || (post.isTikTok ? 'tiktok' : 'instagram'))
      postData.profilePlatform = post.profilePlatform || post.profile_platform || profileOwner.platform || (post.influencer_details || {}).platform || ''
      postData.profileHandle = post.profileHandle || post.profile_handle || (post.influencer_details || {}).instagramHandle || profileOwner.username || ''
      if (post.isCalculated) {
        return post
      }
      if (!['linkedin', 'twitter'].includes(platform) && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isLemon && !post.isFacebook && !post.isOthers) {
        postData.name = post.post_details.owner.username
        postData.url = post.post_details.link
        postData.impressions = 0 // currently no used
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
        postData.engagement_rate_sd = post.post_details.owner.engagement_rate_sd || null
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
        if (post.postType === 'IGR') {
          postData.type = 'reel'
          postData.title = 'IG Reel'
        } else {
          postData.type = 'post/carousel'
          postData.title = 'IG Post'
        }
        // for manual input data for posts
        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved
          postData.shares = post.inputtedInsights.shares
          postData.views = post.inputtedInsights.views || 0 // newly added views, so there could be null
          postData.reach = post.inputtedInsights.reach || 0
          postData.impressions = post.inputtedInsights.impressions || 0
          postData.plays = post.inputtedInsights.plays || 0
          postData.watches = post.inputtedInsights.watches ? campaignHelper.parseWatchTime(post.inputtedInsights.watches) : 0
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0 // bookmarks
          postData.shares = 0 // no data default to 0
          postData.views = 0 // no data default to 0
        }
      } else if (post.isStory && post.insights) {
        postData.name = post.owner.username
        postData.outreach = post.owner.followers || post.owner.followers_sd
        postData.title = 'IG Story'
        postData.url = post.media_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.engagement = Number(post.insights.engagement) || 0
        postData.impressions = Number(post.insights.impressions) || 0
        postData.story_likes = Number(post.insights.story_likes) || 0
        postData.reach = Number(post.insights.reach) || 0
        postData.replies = Number(post.insights.replies) || 0
        postData.exits = Number(post.insights.exits) || 0
        postData.taps_back = Number(post.insights.taps_back) || 0
        postData.taps_forward = Number(post.insights.taps_forward) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.sticker_taps = Number(post.insights.sticker_taps) || 0
        postData.link_clicks = Number(post.insights.link_clicks) || 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
        postData.type = 'story'
        postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1
        postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps + postData.story_likes
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.public_id = post.public_id || null
      } else if (post.isTikTok) {
        postData.name = post.owner.username
        postData.title = 'TikTok Post'
        postData.url = post.post_details.link
        postData.shortCode = post.post_details.shortcode
        postData.impressions = 0 // currently no used
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.shares = post.currentInsight.shares || 0
        postData.views = post.currentInsight.views || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_saves = post.avg_saves ? Number(post.avg_saves) : 0
        postData.avg_shares = post.avg_shares ? Number(post.avg_shares) : 0
        postData.type = 'tiktok'
        // for manual input data for posts
        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved
          if (postData.shares === 0) {
            postData.shares = post.inputtedInsights.shares
          }
          if (postData.views === 0) {
            postData.views = post.inputtedInsights.views || 0 // newly added views, so there could be null
          }
          postData.reach = post.inputtedInsights.reach || 0
          postData.impressions = post.inputtedInsights.impressions || 0
          postData.plays = post.inputtedInsights.plays || 0
          postData.watches = post.inputtedInsights.watches ? campaignHelper.parseWatchTime(post.inputtedInsights.watches) : 0
          postData.watchedFullVideo = post.inputtedInsights.watchedFullVideo || 0
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0 // bookmarks
          postData.shares = 0 // no data default to 0
          postData.views = 0 // no data default to 0
          postData.reach = 0
          postData.impressions = 0
          postData.plays = 0
          postData.watches = 0
          postData.watchedFullVideo = 0
        }
      } else if (post.isYoutube) {
        postData.name = post.owner.username
        postData.title = 'Youtube Post'
        postData.url = post.post_details.link
        postData.shortCode = post.post_details.shortcode
        postData.type = 'youtube'
        postData.impressions = 0 // currently no used
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.views = post.currentInsight.views || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
      } else if (post.isFacebook && post.insights) {
        postData.name = post.owner.username
        postData.outreach = post.owner.followers || post.owner.followers_sd
        postData.title = 'Facebook'
        postData.url = post.media_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.outreach = Number(post.insights.outreach) || 0
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.bookmarks) || 0
        postData.type = 'facebook'
      } else if (post.isXHS && post.insights) {
        postData.name = post.owner.fullName || post.owner.username
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd
        postData.title = 'XHS'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.xhsLink = post.xhsLink || ''
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.watches = Number(post.insights.watches) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.bookmarks) || 0
        postData.type = 'xhs'
        postData.isXHS = true
      } else if (post.isLemon && post.insights) {
        postData.name = post.owner.fullName || post.owner.username
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd
        postData.title = 'Lemon8'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.lemonLink = post.lemonLink || ''
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.watches = Number(post.insights.watches) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.bookmarks) || 0
        postData.type = 'lemon'
        postData.isLemon = true
      } else if (platform === 'twitter' && post.insights) {
        const rawUrl = post.postLink || post.postURL || post.post_details || ''
        const latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null
        const insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights
        const insights = Object.assign({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {})
        postData.name = post.owner.username || post.owner.fullName
        postData.title = 'X (Twitter)'
        postData.url = typeof rawUrl === 'string' ? rawUrl : (rawUrl.link || rawUrl.url || rawUrl.href || '')
        postData.outreach = Number(post.owner.followers || insights.outreach) || 0
        postData.like_count = Number(insights.like_count) || 0
        postData.comment_count = Number(insights.comment_count) || 0
        postData.impressions = Number(insights.impressions != null ? insights.impressions : insights.views) || 0
        postData.views = postData.impressions
        postData.shares = Number(insights.shares) || 0
        postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks
        postData.type = 'twitter'
      } else if (platform === 'linkedin' && post.insights) {
        const rawUrl = post.postLink || post.postURL || post.post_details || ''
        const latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null
        const insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights
        const insights = Object.assign({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {})
        postData.name = post.owner.username || post.owner.fullName
        postData.title = 'LinkedIn'
        postData.url = typeof rawUrl === 'string'
          ? rawUrl
          : (rawUrl.link || rawUrl.url || rawUrl.href || '')
        postData.like_count = Number(insights.like_count) || 0
        postData.comment_count = Number(insights.comment_count) || 0
        postData.impressions = Number(insights.impressions) || 0
        postData.reach = Number(insights.reach != null ? insights.reach : insights.outreach) || 0
        postData.video_views = Number(insights.video_views) || 0
        postData.profile_viewers = Number(insights.profile_viewers) || 0
        postData.shares = Number(insights.shares) || 0
        postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0
        postData.saved = postData.bookmarks
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks
        postData.type = 'linkedin'
      } else if (post.isOthers && post.insights) {
        postData.name = post.owner.fullName || post.owner.username
        postData.outreach = Number(post.insights.outreach) || 0
        postData.title = 'Others'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.postLink = post.postLink || ''
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.watches = Number(post.insights.watches) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.saved) || 0
        postData.plays = Number(post.insights.plays) || 0
        postData.type = 'others'
        postData.isOthers = true
      } else if (post.isMultipleContents) {
        postData.name = post.owner.username
        postData.outreach = post.owner.followers || post.owner.followers_sd
        postData.title = 'IG Story'
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.type = 'gdrive'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.public_id = post.public_id || null
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
        if (post.insights) {
          postData.engagement = Number(post.insights.engagement) || 0
          postData.impressions = Number(post.insights.impressions) || 0
          postData.reach = Number(post.insights.reach) || 0
          postData.replies = Number(post.insights.replies) || 0
          postData.story_likes = Number(post.insights.story_likes) || 0
          postData.exits = Number(post.insights.exits) || 0
          postData.taps_back = Number(post.insights.taps_back) || 0
          postData.taps_forward = Number(post.insights.taps_forward) || 0
          postData.shares = Number(post.insights.shares) || 0
          postData.sticker_taps = Number(post.insights.sticker_taps) || 0
          postData.link_clicks = Number(post.insights.link_clicks) || 0
          postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1
          postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps
        }
      }
      postData.live_date = post.live_date ? utils.func.formatDate(post.live_date) : '-'
      postData.isCalculated = true
      return postData
    },
    refreshReportInf(reportID = null) {
      this.$emit('loading-status', true);
      campaignAPIs
        .generateCampaignReport(this.campaignID, null, true, 'json', reportID)
        .then(async response => {
          if (response && response.success) {
            this.processReportData(response.data)
          }
          this.$emit('loading-status', false);
        })
        .catch(error => {
          this.$emit('loading-status', false);
          console.error(error);
        });
    }
  },
}
</script>

<style lang="scss" >
  body {
    background-color: black !important;
    overflow: hidden;
  }
  html {
    scroll-behavior: smooth;
  }
 
  #internal-report-summary .container {
    max-width: 100%!important;
    padding: 0!important;
    padding-bottom: 10px!important;
  }

  .summary-section .col-header-title {
    float: left;
    padding-right: 5px;
  }
</style>
<style lang="scss" scoped>
    @font-face {
      font-family: Barlow-Regular;
      src: url('/static/fonts/Barlow/Barlow-Regular.ttf');
    }
    @font-face {
      font-family: Barlow-Medium;
      src: url('/static/fonts/Barlow/Barlow-Medium.ttf');
    }
    @font-face {
      font-family: Barlow-Italic;
      src: url('/static/fonts/Barlow/Barlow-Italic.ttf');
    }
    @font-face {
      font-family: Barlow-MediumItalic;
      src: url('/static/fonts/Barlow/Barlow-MediumItalic.ttf');
    }
    #campaign-report {
      font-family: Barlow-Regular;
      background-color: #000;
      height: 100%;
    }
    .fab-btn-up {
        display: none;
    }
    .hero-container {
      background-color: #000;
      height: 100%;
    }
    .scroll {
        cursor: pointer;
        text-align: center;
        margin-top:10%;
        width: 40px;
        height: 40px;
        border: 2px solid #3F3FFF;
        border-radius: 50%;
        position: relative;
        animation: down 1.5s infinite;
        margin-left: auto;
        margin-right: auto;
        -webkit-animation: down 1.5s infinite;
        &::before {
            content: '';
            position: absolute;
            top: 10px;
            left: 11px;
            width: 12px;
            height: 12px;
            border-left: 2px solid #3F3FFF;
        border-bottom: 2px solid #3F3FFF;
            transform: rotate(-45deg);
        }
    }

    @keyframes down {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translateY(15px);
        }
        40% {
            transform: translate(0);
        }
    }

    @-webkit-keyframes down {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translateY(15px);
        }
        40% {
            transform: translate(0);
        }
    }
    .hero {
        // position: absolute;
        background-image: url('/static/img/report/html-rpt-bg.jpg');
        background-position: center center;
        background-color: #050000;
        background-repeat: no-repeat;
        // background-attachment: fixed;
        background-size: cover;
        width: 100%;
        height: 938px;
        box-shadow:inset 0 0 0 2000px rgba(32, 26, 26, 0.8);
    }
    .v-parallax__image {
        transform: none !important;
        width: 100% !important;
    }
    .hero-bg {
        background-color: #000000;
        width:100%;
    }

    .client {
        position: absolute;
        top:10px;
        padding-left:20px;
        padding-top:30px;
    }
    .client-name {
        color:white;
        margin-left:20px;
        font-size:30px;
        font-weight:400;
    }
    .client-logo {
          width: 250px;
    }
     .current-date {
        color:white;
        margin-left:20px;
        font-size:14px;
        font-weight:300;
    }

    .campaign {
        position: absolute;
        top:200px;
        width:100%;
        color:white;
        text-align: center;
        font-size:48px;
        font-weight: 600;
    }

    .objective-div {
        color:white;
        display: flex;
        margin-top:50px;
    }
    .objectives-title {
        font-size:30px;
        font-weight: 400;
        // margin-right: 100px;
        width:300px;
        // flex:1;
        text-align: left;
        margin-left: auto;
        margin-right: auto;
    }
    .objective {
        margin-top:18px;
        font-size: 20px;
        font-weight: 300;
        text-align: left;
    }
    .deliverable-title {
        text-align: left;
        font-size:30px;
        font-weight: 400;
        // margin-left: 100px;
        margin-left: auto;
        margin-right: auto;
    }
    .deliverable {
        margin-top:18px;
        font-size: 20px;
        font-weight: 300;
        text-align: left;
    }

    #indicator {
    //   padding-left: 10px;
      list-style-type: none;
      font-size:14px;
      line-height: 40px;
      color: white;
    }

    #sideNavContents {
        // width:150px;
        position:fixed;
        top: 60%;
        right:0px;
        z-index:1005;
        // background:#212121;
        // border:1px solid;
        // border-radius: 5px;
        // padding:7px;
        // opacity: 0.9;
    }

    #campaignSummary,
    #post,
    #postSummary,
    #storySummary,
    #tiktokSummary,
    #performance
     {
      background-color: rgb(0, 0, 0)
    }

    #internal-report-summary #postSummary,
    #internal-report-summary #storySummary,
    #internal-report-summary #tiktokSummary {
      background-color: #fff
    }
    // .group-title {
    //   color: rgb(255, 183, 77);
    //   font-size: 30px;
    //   border-bottom: 1px solid #212121;
    //   padding-bottom: 10px;
    // }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 800px) {
        .hero-container {
            height: 400px;
        }
        .scroll {
            display:none;
            cursor: pointer;
            margin-top:0px;
            width: 20px;
	        height: 20px;
            &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 5px;
                width: 6px;
                height: 6px;
                border-left: 2px solid #3F3FFF;
                border-bottom: 2px solid #3F3FFF;
                transform: rotate(-45deg);
            }
        }
        .client {
            position: absolute;
            top:10px;
            width:100%;
            text-align:center;
            padding-left:0px;
            padding-top:10px;
        }
        .client-name {
            color:white;
            margin-left:20px;
            font-size:14px;
            font-weight:400;
        }
        .client-logo {
          width: 150px;
          margin-left:auto;
          margin-right: auto;
        }
        .current-date {
            color:white;
            margin-left:20px;
            font-size:12px;
            font-weight:300;
        }

        .campaign {
            position: absolute;
            top:150px;
            width:100%;
            color:white;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
        }

        .objective-div {
            margin-top:20px;
            width: 100%;
            color:white;
            display: block;
            padding:10px;
            left:0px;
        }

        .objectives-title {
            font-size:14px;
            font-weight: 400;
            margin-right: 100px;
            width:300px;
            flex:0;
            margin-left: 0;
            margin-right: 0;
        }

        .objective {
            margin-top:10px;
            font-size: 12px;
            font-weight: 300;
            text-align: left;
            width:100%;
        }

        .deliverable-title {
            font-size:14px;
            font-weight: 400;
            margin-left: 0px;
            margin-right: 0;
        }
        .deliverable {
            margin-top:10px;
            font-size: 12px;
            font-weight: 300;
            text-align: left;
        }
    }

    @media  (min-width: 800px) and (max-width: 1176px) {
         .hero-container {
            height: 550px;
        }
        .scroll {
            cursor: pointer;
            margin-top:20px;
            width: 20px;
	        height: 20px;
            &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 5px;
                width: 6px;
                height: 6px;
                border-left: 2px solid #3F3FFF;
                border-bottom: 2px solid #3F3FFF;
                transform: rotate(-45deg);
            }
        }
        .client {
            position: absolute;
            top:10px;
            padding-left:20px;
            padding-top:30px;
        }
        .client-name {
            color:white;
            margin-left:20px;
            font-size:20px;
            font-weight:400;
        }
        .client-logo {
            width: 200px;
        }
        .current-date {
            color:white;
            margin-left:20px;
            font-size:12px;
            font-weight:300;
        }

        .campaign {
            position: absolute;
            top:100px;
            width:100%;
            color:white;
            text-align: center;
            font-size:45px;
            font-weight: 600;
        }

        .objective-div {
            color:white;
            display: flex;
            margin-top:50px;
        }
        .objectives-title {
            font-size:25px;
            font-weight: 400;
            width:300px;
            text-align: left;
            margin-left: auto;
            margin-right: auto;
        }
        .objective {
            margin-top:18px;
            font-size: 16px;
            font-weight: 300;
            text-align: left;
        }
        .deliverable-title {
            text-align: left;
            font-size:25px;
            font-weight: 400;
            margin-left: auto;
            margin-right: auto;
        }
        .deliverable {
            margin-top:18px;
            font-size: 16px;
            font-weight: 300;
            text-align: left;
        }
    }

</style>



// WEBPACK FOOTER //
// ReportForSummary.vue?0b9e2102